import { Component } from '@angular/core';
import {
  FieldType,
  FormlyExtension,
  FormlyFieldConfig
} from '@ngx-formly/core';
import { sharedAddress } from '../../form-parts-definition';

@Component({
  selector: 'tpa-address',
  templateUrl: './address.component.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: { class: 'tpa-wrapper__control' },
})
export class AddressComponent extends FieldType implements FormlyExtension {
  defaultOptions = {
    className: 'p-col-12',
    props: {
      translate: true,
      full: true,
      open: false,
    },
  };

  get emptyModel() {
    return !this.model || JSON.stringify(this.model) === '{}';
  }

  onPopulate(field: FormlyFieldConfig) {
    if (field.fieldGroup) {
      return;
    }

    field.fieldGroup = sharedAddress();

  }
}
